import { PropsWithChildren } from 'react';
import { Badge } from '@/components/ui/badge';
import { useAppAuth } from '@/hooks/useAppAuth';

const ALLOWED_ROLES = ['admin', 'builder'];

function getUserRoleNames(user: any): string[] {
  const roles = user?.roles || [];
  return roles
    .map((r: any) => (typeof r === 'string' ? r : r?.name || r?.key || ''))
    .filter(Boolean);
}

function userCanViewSourceData(user: any): boolean {
  if (!user) return false;
  return getUserRoleNames(user).some((name: string) =>
    ALLOWED_ROLES.includes(name.toLowerCase())
  );
}

interface Props {
  nodeType: string | undefined;
}

export function SourceDataGate({ nodeType, children }: PropsWithChildren<Props>) {
  const { user } = useAppAuth();

  if (nodeType !== 'SOURCE') {
    return <>{children}</>;
  }

  if (!user) {
    return null;
  }

  if (userCanViewSourceData(user)) {
    return <>{children}</>;
  }

  const primaryRole = getUserRoleNames(user)[0] || 'Unknown';

  return (
    <div className="flex flex-col items-center justify-center h-full gap-3 p-8 text-center">
      <div className="text-sm text-muted-foreground">
        Your current role{' '}
        <Badge variant="secondary" className="mx-1">
          {primaryRole}
        </Badge>{' '}
        does not allow viewing source data.
      </div>
      <div className="text-sm text-muted-foreground">
        Contact your account admin.
      </div>
    </div>
  );
}
